import { GREY_META, OPTION_COLOR_THEMES, OPTION_COLOR_THEMES_MAP } from './constants';
import type { OptionColorMeta } from './types';

export const getColorMetadata = (colorName: string | null | undefined): OptionColorMeta => {
	if (!colorName) {
		return GREY_META;
	}
	return OPTION_COLOR_THEMES_MAP[colorName] ?? GREY_META;
};

export const getAllColorNames = (): string[] => OPTION_COLOR_THEMES.map((item) => item.name);
